import { createRoot } from 'react-dom/client';
import { Toast } from '@travellegacy/nexops-design-system';

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastOptions {
  message: string;
  description?: string;
  type?: ToastType;
}

export function toast({ message, description, type = 'info' }: ToastOptions) {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const root = createRoot(container);

  const handleClose = () => {
    root.unmount();
    document.body.removeChild(container);
  };

  root.render(
    <Toast type={type} message={message} description={description} onClose={handleClose} />
  );
}

// Helper methods
toast.success = (message: string, description?: string) => {
  toast({ message, description, type: 'success' });
};

toast.error = (message: string, description?: string) => {
  toast({ message, description, type: 'error' });
};

toast.warning = (message: string, description?: string) => {
  toast({ message, description, type: 'warning' });
};

toast.info = (message: string, description?: string) => {
  toast({ message, description, type: 'info' });
};
